module.exports = __webpack_public_path__ + "static/img_4323-c4d8355927fd070e7f43cc8a7800e45a.webp";